var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AttachmentDiagramCard"},[_c('d-image',{staticClass:"attachments__diagram--img",attrs:{"aspect-ratio":16 / 9,"src":_vm.imgURL,"contain":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }